export default "__VITE_ASSET__$IplmLzD__"